export interface AuthFormState {
  error: string | null;
}

export const INITIAL_AUTH_FORM_STATE: AuthFormState = {
  error: null,
};
